const getHeatIndex = (tempFahrenheit, relativeHumidity) => {

  tempFahrenheit = parseFloat(tempFahrenheit);
  relativeHumidity = parseFloat(relativeHumidity);

  // ignore if the temperature is outside of the bounds of typical heat index calculation
  if(tempFahrenheit < 70) {
    return tempFahrenheit;
  }

  // simple
  let heatIndex = 0.5 * (tempFahrenheit + 61 + ((tempFahrenheit-68) * 1.2) + (relativeHumidity*0.094));
  heatIndex = (tempFahrenheit + heatIndex) /  2;

  // use simple if index is less than 80
  if(heatIndex < 80) {
    return Math.round(heatIndex);
  }

  // advanced
  const equation = [
    -42.379, // flat
    2.04901523, // * T
    10.14333127, // * RH,
    -.22475541, // * T * RH
    -.00683783, // * T * T
    -.05481717, // * RH * RH
    .00122874, // * T * T * RH
    .00085282, // * T * RH * RH
    -.00000199, // * T * T * RH * RH
  ];

  heatIndex =
    equation[0] +
    (equation[1] * tempFahrenheit) +
    (equation[2] * relativeHumidity) +
    (equation[3] * tempFahrenheit * relativeHumidity) +
    (equation[4] * tempFahrenheit * tempFahrenheit) +
    (equation[5] * relativeHumidity * relativeHumidity) +
    (equation[6] * tempFahrenheit * tempFahrenheit * relativeHumidity) +
    (equation[7] * tempFahrenheit * relativeHumidity * relativeHumidity) +
    (equation[8] * tempFahrenheit * tempFahrenheit * relativeHumidity * relativeHumidity);

  if(relativeHumidity < 13 && tempFahrenheit > 80 && tempFahrenheit < 112) {

    const adjustment = ((13 - relativeHumidity) / 4) * Math.sqrt((17 - Math.abs(tempFahrenheit - 95)) / 17);
    heatIndex -= adjustment;

  } else if(relativeHumidity > 85 && tempFahrenheit > 80 && tempFahrenheit < 87) {

    const adjustment = ((relativeHumidity - 85) / 10) * ((87 - tempFahrenheit) / 5);
    heatIndex += adjustment;

  }

  return Math.round(heatIndex);

}

export default getHeatIndex;
